module.exports = __webpack_public_path__ + "icon-windows@2x.png?3d8fb7e1d98a41188d7de063ce880c15";